import { useAtomValue } from 'jotai';
import { dcbAtom } from '@shared/store/slice-atoms';
import { useLocation } from 'react-router-dom';

export const useLocationHasParticularOperator = (_operator: string): boolean => {
  const location = useLocation();
  const { operator } = useAtomValue(dcbAtom);

  // in the url it can come ksazain, in operators list it can be ksa-zain
  if (_operator.toLowerCase() === 'ksa-zain' || _operator.toLowerCase() === 'ksazain') {
    return location.pathname.includes('ksazain') || operator?.value?.toLowerCase() === 'ksa-zain';
  }

  return (
    location.pathname.includes(_operator) ||
    operator?.value?.toLowerCase() === _operator.toLowerCase()
  );
};
